import React from 'react';
import DashboardThemeToggle from '../dashboard/DashboardThemeToggle';
import NotificationBell from '../notifications/NotificationBell';
import TestnetFaucetLink from './TestnetFaucetLink';
import Profile from '../../Modal/Profile';

/**
 * Header actions: minimal on small screens (bell + wallet icon), full on lg+.
 * Faucet and theme live in the mobile drawer; desktop shows them in the top bar.
 */
const HeaderToolbar = () => (
    <>
        <div className="hidden shrink-0 items-center gap-2 lg:flex lg:gap-3">
            <TestnetFaucetLink compact />
            <NotificationBell />
            <Profile />
        </div>
        <div className="flex shrink-0 items-center gap-1.5 lg:hidden">
            <NotificationBell />
            <Profile compact />
        </div>
    </>
);

export const HeaderDrawerExtras = () => (
    <div className="mb-4 px-1">
        <TestnetFaucetLink className="w-full justify-center py-2.5" />
    </div>
);

export const HeaderDrawerFooter = () => (
    <>
        <p className="mb-3 px-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-zinc-500 dark:text-zinc-500">
            Appearance
        </p>
        <div className="mb-4 px-1">
            <DashboardThemeToggle />
        </div>
        <p className="mb-3 px-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-zinc-500 dark:text-zinc-500">
            Account
        </p>
        <Profile isMobile />
    </>
);

export default HeaderToolbar;
